import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import CardFormContainer from '../../containers/card-form-container/cardFormContainer';
import { getIdFromPath } from '../../utils/utils';
import { getSupervisorPassword } from '../../actions/supervisors';
import { Input, Button, Popover, Skeleton } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

const ResetPasswordInspectorScreen = () => {
	const location = useLocation();
	const id = getIdFromPath(location.pathname);
	const dispatch = useDispatch();
	const supervisor = useSelector((state) => state.supervisors.supervisors.filter(obj => obj.id == id)[0]);
	const isLoading = useSelector((state) => state.supervisors.isResettingPassword);
	const password = useSelector((state) => state.supervisors.newPassword);

	useEffect(() => {
		dispatch(getSupervisorPassword(id));
	}, []);

	return (
		<CardFormContainer title={'Cambio de contraseña'}>
			<p> {'La nueva contraseña de ' + supervisor.email + ' es'} </p>
			{
				isLoading ?
					<Skeleton.Input style={{ width: 300 }} active="true" size="large" block="true" shape="round" /> :
					<Input size="large" addonAfter={
						<Popover content="Copiado!" trigger="click">
							<Button onClick={() => { navigator.clipboard.writeText(password) }} type="text" icon={<CopyOutlined />} />
						</Popover>

					} value={isLoading ? "" : password} readOnly={true} />
			}
		</CardFormContainer>
	);
};

export default ResetPasswordInspectorScreen;
